import { Decoder, number, object, string } from '@mojotech/json-type-validation'

import { ReviewRequestItem } from '@/domain/entities/reviewRequest/reviewRequestItem'

export const ReviewRequestItemDecoder: Decoder<ReviewRequestItem> = object({
  id: string(),
  status: string(),
  level: number(),
  message: string()
})
